module.exports = __webpack_public_path__ + "static/img/banner2.9b1a07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.png
// module id = i4Cj
// module chunks = 63